export function isEmployeeEmail(email = "") {
  if (!email || typeof email !== "string") {
    return false;
  }
  return email.endsWith("wrstudios.com") || email.endsWith("wr-studios.com") || email.endsWith("lwolf.com") || email.endsWith(".lwolf@gmail.com") ;
}
